import { Label, Details, Root } from './style';

import type { FC, HTMLAttributes } from 'react';
import type { AutocompleteRenderOptionState } from '@mui/material/Autocomplete/Autocomplete';
import type { Suggestion } from '../../types';

type Props = {
  tagProps: HTMLAttributes<HTMLLIElement>;
  suggestion: Suggestion;
  state: AutocompleteRenderOptionState;
};

export const AddressOption: FC<Props> = ({ tagProps, suggestion }) => (
  <Root {...tagProps}>
    <Label>{`${suggestion.street} ${suggestion.houseNumber || ''}`}</Label>
    <Details>
      {suggestion.zipCode}&nbsp;{suggestion.city}, {suggestion.country}
    </Details>
  </Root>
);
